module.exports = __webpack_public_path__ + "static/media/ei_example.27af0471.png";